import moment from 'moment';

import { formatPhoneToInt } from './format';

export const daysInMonth = (m, y) => {
  switch (m) {
    case 1:
      return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28;
    case 8:
    case 3:
    case 5:
    case 10:
      return 30;
    default:
      return 31;
  }
};

export const isValidDate = (d, m, y) => {
  const month = parseInt(m, 10) - 1;
  return month >= 0 && month < 12 && d > 0 && d <= daysInMonth(month, y);
};

export const validateZipCode = value => {
  if (!value) {
    return false;
  }

  return `${value}`.replace(/[^0-9]/g, '').length === 8;
};

export const validateDateString = value => {
  if (!value) {
    return false;
  }

  const [d, m, y] = value.split('/');
  return d && m && y && isValidDate(d, m, y);
};

export const validatePhone = value => {
  const testValue = `${value ? formatPhoneToInt(value) : ''}`;

  if (testValue.length === 10 || testValue.length === 11 || testValue.length === 0) {
    return true;
  }
  return false;
};

export const isValidName = value => {
  const regex = /([0-9])/g;
  return !regex.test(value);
};

export const isLegalAge = value => {
  if (!value) {
    return false;
  }

  const [d, m, y] = value.split('/');
  return (
    d && m && y && isValidDate(d, m, y) && moment().diff(moment(`${m}/${d}/${y}`), 'years') > 18
  );
};

export function onlyNumbers(str) {
  return str.match(/\d/g).join('');
}

export function isValidCpf(stringCpf) {
  const cpfValue = stringCpf ? onlyNumbers(stringCpf) : '';
  let cpfSum;
  let cpfRest;
  cpfSum = 0;

  if (cpfValue !== undefined && cpfValue.length >= 11) {
    if (
      cpfValue === '00000000000' ||
      cpfValue === '11111111111' ||
      cpfValue === '22222222222' ||
      cpfValue === '33333333333' ||
      cpfValue === '44444444444' ||
      cpfValue === '55555555555' ||
      cpfValue === '66666666666' ||
      cpfValue === '77777777777' ||
      cpfValue === '88888888888' ||
      cpfValue === '99999999999'
    ) {
      return false;
    }

    for (let i = 1; i <= 9; i += 1) {
      // eslint-disable-next-line radix
      cpfSum += parseInt(cpfValue.substring(i - 1, i)) * (11 - i);
    }
    cpfRest = (cpfSum * 10) % 11;

    if (cpfRest === 10 || cpfRest === 11) cpfRest = 0;
    // eslint-disable-next-line radix
    if (cpfRest !== parseInt(cpfValue.substring(9, 10))) return false;

    cpfSum = 0;
    for (let i = 1; i <= 10; i += 1) {
      // eslint-disable-next-line radix
      cpfSum += parseInt(cpfValue.substring(i - 1, i)) * (12 - i);
    }

    cpfRest = (cpfSum * 10) % 11;

    if (cpfRest === 10 || cpfRest === 11) cpfRest = 0;
    // eslint-disable-next-line radix
    if (cpfRest !== parseInt(cpfValue.substring(10, 11))) return false;
    return true;
  }

  return false;
}
